import { render, staticRenderFns } from "./MaterialBlock.vue?vue&type=template&id=4f776fde&scoped=true&"
import script from "./MaterialBlock.vue?vue&type=script&lang=js&"
export * from "./MaterialBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f776fde",
  null
  
)

export default component.exports